import { Modal } from 'react-bootstrap';
import Kitchen from '../../../components/Kitchen';
import { useState } from 'react';
import { patch } from '../../../services/apiController';
import { toast } from 'react-toastify';

export default function KitchenUpdateModal({ view, setView, factoryId, kitchenId, productionIndentId, callback, label, type }) {
  const [updatedKitchenId, setUpdatedKitchenId] = useState(kitchenId);
  const handleSubmit = (e) => {
    e.preventDefault();
    patch({ kitchenId: updatedKitchenId }, `/inv/production-indent/${productionIndentId}`)
      .then((res) => {
        toast.success(label ? 'Location updated successfully' : 'Kitchen updated successfully');
        setView(false);
        callback();
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message || err.message));
  };
  return (
    <Modal size="sm" show={view} backdrop="static" keyboard={false} className="request-modal">
      <Modal.Header>
        <Modal.Title>{label ? label : 'Update Kitchen'}</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={() => setView(false)}></button>
      </Modal.Header>
      <Modal.Body>
        <Kitchen
          query={`factoryId=${factoryId}&type=${type ?? ''}`}
          kitchenId={updatedKitchenId}
          onChange={(kitchenId) => setUpdatedKitchenId(kitchenId)}
          name="kitchenId"
        />
      </Modal.Body>
      <Modal.Footer>
        <div className="btn-wrapper">
          <button
            onClick={() => {
              setView(false);
            }}
            className="btn app-btn-default btn-sm"
          >
            Cancel
          </button>
          <button onClick={handleSubmit} className="btn app-btn-primary btn-sm">
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
